const $ = require('jquery');
const Modernizr = require('../../vendors/modernizr.min');
const _debounce = require('lodash/debounce');
const WS = require('../../scripts/ws.js');
const Dialog = require("./dialog");
require('./popover');

$(function () {
    // Hero Spotlight Madlib
    // Only the last madlib should update the button
    let $select = $(".ws-madlib.ws-madlib--spotlight .ws-madlib__select").last();
    let $madlibButton = $(".ws-madlib.ws-madlib--spotlight .ws-madlib__btn");
    let $inlineSelect = $(".ws-select--layout_inline select");
    let inputSelector = '.ws-material-group__input, .ws-material-group__text-area, .ws-material-group__select > select';
    let autocompleteItemSelector = '.ws-textbox-autocomplete__list-item-link';
    let formContentSuccessClassName = 'ws-content--custom-form-success';
    let formElementSuccessClassName = 'ws-form-element--success';
    let dialogResultsDisplayedClassName = 'ws-dialog--results-displayed';
    let recaptchaSelector = '.ws-recaptcha';
    let recaptchaEagerLoadSelector = '.ws-recaptcha--loading_eager';
    let recaptchaResponseSelector = '.ws-recaptcha__response';
    let inputMaskSelector = "input[data-mask], input[data-val-zip-mask]";
    let recaptchaInitialized = false;
    let inputMaskInitialized = false;

    function init() {
        // Dropdown selection needs be set to first option since this is what the button's inital href will be set to
        $select.prop("selectedIndex", 0);

        resizeAllSelects();
        setTimeout(resizeAllSelects, 50);

        let $inputs = $(inputSelector);

        $.each($inputs, function (index, item) {
            toggleHasValueClass($(item));
            if (Modernizr.browsertouch && $(item).hasClass("ws-material-group--hide-keyboard")) {
                $(item).focus(function () {
                    hideKeyboard($(item));
                });
            }
        });

        if ($('input[data-mask]').length > 0) {
            initializeInputMask();
        }

        if (Modernizr.browsertouch) {
            // touch devices display listboxes as dropdowns and ignore the size attribute but browser device emulation does not,
            // so we're removing the attribute here to ensure consistent behavior between device and browser emulation
            $(".ws-material-group__listbox select").removeAttr("size").on("blur", function (e) {
                // force listboxes to invalidate on blur on touch devices, to make them consistent with dropdowns
                $(this).valid();
            });
        }

        if ($("[data-val='true']").length > 0) {
            import(/* webpackChunkName: "validation" */ "../../scripts/validation");
        }

        if ($('.ws-form--custom, .ws-claims-wizard__step-form').length > 0) {
            import(/* webpackChunkName: "custom-forms" */ "../../scripts/custom-forms");
        }

        // Adjust spacing between Page Intro Content Blocks and Forms based on optional content
        let $pageIntroCB = $(".ws-section--page-intro-content-block");
        let $supportingContent = $pageIntroCB.children(".ws-section__supporting-content");
        let $customForm = $pageIntroCB.next(".ws-section__item--custom-form-wrapper");
        let $hardCodedForm = $supportingContent.children(".ws-form__container");

        if ($hardCodedForm.length ||
            (
                // Custom Form
                !$supportingContent.children().length &&
                $customForm.length &&
                !$customForm.find(".ws-form-wrapper__crc-closed-message, .ws-material-group__form-header").length
            )) {
            $pageIntroCB.children(".ws-section__item").css("padding-bottom", 25);
        }

        setFormGroupValidationOffsets();
        toggleStylesForIE();

        // any recaptchas marked for eager loading should be initialized on page load (i.e. used on postbacks)
        $(recaptchaEagerLoadSelector).each(function (index, el) {
            let $form = $($(el).data("ws-target-form"));
            initializeRecaptcha($form);
        });
    }

    function selectResize($select) {
        let $selected = $select.find(":selected").clone(false);
        let $hiddenElement = $select.clone(false);

        $hiddenElement
            .insertAfter($select)
            .css("width", "auto")
            .html($selected);

        $select.width($hiddenElement.width());
        $hiddenElement.remove();
    }

    function resizeAllSelects() {
        $inlineSelect.each(function () {
            selectResize($(this));
        });
    }

    function toggleAllHasValueClasses() {
        let $inputs = $(inputSelector);

        $.each($inputs, function (index, item) {
            toggleHasValueClass($(item));
        });
    }

    function toggleHasValueClass($el) {
        // the ternary operator below doesn't seem like it should be necessary, but without it the expression was evaluating to an
        // empty string instead of false if $el.val() returned an empty string. don't remove unless you are able to fix that use case.
        // number input types report the value as "" even if there is text in the field, if it's an invalid number (e.g. "e"),
        // the badInput property allows us to see if there is an invalid value entered (hence, the field is not actually blank)
        let hasInputValue = ($el.val() && $el.val().length > 0) || ($el[0].type === "number" && $el[0].validity && $el[0].validity.badInput);
        $el.parents('.ws-material-group').toggleClass('ws-material-group--has-value', hasInputValue ? true : false);
    }

    function formatPhoneNumber(el) {
        let lastValue = '';

        setTimeout(function () {
            let originalValue = el.value;
            if (originalValue === lastValue) {
                return;
            }

            // only format if there are only numbers and hyphens in the box
            if (originalValue !== originalValue.replace(/[^\d\-]+/g, "")) {
                return;
            }

            let selectionStart = el.selectionStart,
                selectionEnd = el.selectionEnd;
            let beforeCursor = originalValue.substring(0, selectionStart);
            let nonDigits = beforeCursor.replace(/\d/g, "");
            selectionStart -= nonDigits.length;
            selectionEnd -= nonDigits.length;

            let digitsOnly = originalValue.replace(/\D/g, "");
            let digits = digitsOnly.split("");

            if (digits.length > 3) {
                digits.splice(3, 0, "-");

                if (selectionStart > 3) {
                    selectionStart++;
                }

                if (selectionEnd > 3) {
                    selectionEnd++;
                }
            }

            if (digits.length > 7) {
                digits.splice(7, 0, "-");

                if (selectionStart > 7) {
                    selectionStart++;
                }

                if (selectionEnd > 7) {
                    selectionEnd++;
                }
            }

            lastValue = digits.join("");
            el.value = lastValue;

            el.selectionStart = selectionStart;
            el.selectionEnd = selectionEnd;
        });

    }

    function hideKeyboard(el) {
        el.addClass("ws-form__element--ignore-validation");
        el.attr("readonly", "true"); // hide keyboard on normal input
        el.attr("disabled", "true"); // hide keyboard on textarea
        setTimeout(function () {
            el.blur();
            // Remove attributes after keyboard is hidden.
            el.removeAttr('readonly');
            el.removeAttr('disabled');
            el.removeClass("ws-form__element--ignore-validation");
        }, 100);
    }

    function initializeRecaptcha($form, force = false) {
        if (recaptchaInitialized && !force) {
            return;
        }

        // only initialize recaptcha if the form that received focus has a recaptcha element
        if (!$form.find(recaptchaResponseSelector).length) {
            return;
        }

        recaptchaInitialized = true;

        let $recaptchas = $(recaptchaSelector);
        if ($recaptchas.length > 0) {
            window.onloadCallback = function () {
                try {
                    grecaptcha.reset();
                } catch { }

                $recaptchas.find(".g-recaptcha").each(function (index, el) {
                    let $el = $(el);

                    if (Modernizr.mq('(max-width: 419px)')) {
                        // setting this data attribute using data() didn't seem to be recognized
                        // by the recaptcha API, so using attr() instead
                        if ($el.attr('data-size') !== 'invisible') {
                            $el.attr('data-size', 'compact');
                        }
                    }

                    if (!$el.find("iframe").length) {
                        let widgetId = grecaptcha.render($el.attr('id'));
                        $el.parents("form").data("recaptchaWidgetId", widgetId);
                        //Added for ADA compliance of iFrame 
                        $el.find("iframe").attr("title", "Google Recaptcha");
                    }
                });
            };

            $.getScript('https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit&tabindex=-1');
        }
    }

    function initializeInputMask() {
        if (inputMaskInitialized) {
            return;
        }

        inputMaskInitialized = true;

        import(/* webpackChunkName: "inputmask" */ "inputmask").then(({ default: Inputmask }) => {
            Inputmask.extendDefaults({
                showMaskOnHover: false
            });

            // Zip code mask
            Inputmask({
                mask: ['99999', '99999-9999'],
                jitMasking: true
            }).mask('input[data-mask="zip-code"]');

            //Used in Custom Form Builder
            Inputmask({
                mask: ['99999', '99999-9999'],
                jitMasking: true
            }).mask('input[data-val-zip-mask="zip-code"]');

            // Currency mask
            Inputmask({
                alias: 'currency',
                prefix: '$',
                groupSeparator: ',',
                autoUnmask: true,
                allowMinus: true,
                rightAlign: false,
                digits: '0',
                digitsOptional: true,
                placeholder: ''
            }).mask('input[data-mask="currency"]');

            // Percentage mask
            Inputmask({
                alias: 'percentage',
                suffix: '%',
                groupSeparator: ',',
                autoUnmask: true,
                allowMinus: true,
                rightAlign: false,
                digits: '0',
                placeholder: '',
                min: '-100',
                max: ''
            }).mask('input[data-mask="percentage"]');

            // Date mask
            Inputmask({
                mask: ['99/9', '99/99', '99/99/9', '99/99/9999'],
                jitMasking: true
            }).mask('input[data-mask="date-mask"]');

            // SSN mask
            Inputmask({
                mask: "999-99-9999",
                jitMasking: true
            }).mask('input[data-mask="ssn"]');

            // Non-negative integer mask
            Inputmask('integer', {
                allowMinus: false,
                autoGroup: true,
                autoUnmask: true,
                groupSeparator: ','
            }).mask('input[data-mask="nonnegative-int"]');
        });
    }

    function setFormGroupValidationOffsets() {
        let $labelTopInputs = $("form div.ws-material-group--label_top");
        $labelTopInputs.each(function () {
            let $infoIcon = $(this).find("button.ws-form-element__information-icon");
            if ($infoIcon.length) {
                $infoIcon.addClass("ws-form-element__information-icon_offset");
            }
        });
    }

    function toggleStylesForIE() {
        if (window.document.documentMode) {
            let $success = $(".ws-success");
            let $wrapper = $(".ws-dialog__content-wrapper");

            // Fix for IE returning ajax results on submit
            setTimeout(function () {
                $success.removeClass("d-none");
                $success.css("flex-basis", "");
                $wrapper.css("width", "");
            }, 100);
            setTimeout(function () {
                $success.addClass("d-none");
                $success.css("flex-basis", "100%");
                $wrapper.css("width", "auto");
            }, 0);
        }
    }

    function applyStickyCtas($form) {
        let $dialog = $form.parents(".ws-dialog");
        let $ctas = $dialog.find(".ws-success .ws-success__cta-container");
        let $stickyCtaSection = $dialog.find(".ws-dialog__cta-section");
        if ($ctas.length && $ctas.children().length && $stickyCtaSection.length) {
            $stickyCtaSection.html($ctas);
            $dialog.addClass("ws-dialog--sticky-ctas");
        }
    }

    function clearStickyCtas($form) {
        let $dialog = $form.parents(".ws-dialog");
        $dialog.removeClass("ws-dialog--sticky-ctas");
    }

    function resetForm($formContent) {
        let $form = $formContent.find("form");

        $formContent.trigger("formReset");

        $formContent.toggleClass(formContentSuccessClassName, false);
        $form.toggleClass(formElementSuccessClassName, false);
        $formContent.find(".ws-form__success-message").remove();
        toggleRelatedFormFields($form, true);

        scrollToFormTop($form);
    }

    function displaySuccessMessage($form) {
        const $formContent = $form.parents(".ws-content--custom-form");
        if ($formContent.hasClass(formContentSuccessClassName)) {
            return;
        }

        $formContent.toggleClass(formContentSuccessClassName, true);
        toggleRelatedFormFields($form, false);

        $formContent.trigger("formSuccess");

        const $successMessage = $form.find(".ws-form__success-message");


        if ($formContent.parents('.ws-cta-block__form').length < 1) {
            setTimeout(function () {
                WS.scrollFormToCenter($form, $successMessage);
            }, 10);
        }

        if ($("#ws-success-auto-refresh").length) {
            let timeoutString = $("#ws-success-auto-refresh").attr("data-refresh-timeout");
            //Parsing as integer and converting to seconds
            let timeoutLength = (parseInt(timeoutString, 10) || 0) * 1000;
            //Making sure we have a value of at least 1 second for the delay. If not, the timeoutString was probably input incorrectly in formbuilder.
            if (timeoutLength > 999) {
                setTimeout(function () {
                    resetForm($formContent);
                }, timeoutLength);
            }
            
        }

        pushFormSubmissionGTMEvent("inPageFormSubmission", $form.find(".ws-form--custom").data("form-name"), window.location.href);
    }

    function ajaxSubmit($wrapper, hideForm) {
        let $dialog = $wrapper.parents(".ws-dialog");
        let isModal = $dialog.length;
        let isCalcXML = !hideForm;

        // if this is a submit within a modal, display the success message and hide the form
        if (hideForm && isModal) {
            displayModalResults($dialog);
        }

        // if this is a modal or a calculator in-page, hide the fields
        // in-page success messages handle this separately
        if (isModal || !hideForm) {
            $wrapper.find(".ws-form__fields").addClass("d-none");
            $wrapper.find(".ws-material-group__required-fields").addClass("d-none");
        }

        if (isModal && !isCalcXML) {
            pushFormSubmissionGTMEvent("formModalSubmission", $wrapper.find(".ws-form--custom").data("form-name"), window.location.href);
        }
    }

    function displayModalResults($dialog) {
        // display the results if there are any. Close the modal if not
        $dialog.toggleClass(dialogResultsDisplayedClassName, true);

        if (!$dialog.data("ws-has-results")) {
            Dialog.closeDialog();
        }
    }

    function pushFormSubmissionGTMEvent(eventName, formName, formURL) {
        // Push custom form submission event to Google Tag Manager dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": eventName,
            "formName": formName,
            "formURL": formURL
        });
    }
    
    function pushFormNavigationGTMEvent(formName, navigationType, navigationLabel) {
        // Push form page navigation event to Google Tag Manager dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": "formPageNavigation",
            "formName": formName,
            "formNavigationType": navigationType,
            "formNavigationLabel": navigationLabel
        });
    }

    /**
    * Auto scrolls to the top of the form.
    * @param {jQuery} $form - The jQuery object representing the form to focus.
    * @param {number} [offset=(window.innerWidth < 992) ? 80 : 175] - Default offset values for mega menu height.
    */
    function scrollToFormTop($form, offset = (window.innerWidth < 992) ? 80 : 175) {
        let $formModal = $form.parents(".ws-dialog__content-wrapper");
        let isModalForm = $formModal.length > 0;
        let $scrollTarget = isModalForm
            ? $formModal
            : $('html, body');

        $scrollTarget.animate({
            scrollTop: isModalForm ? 0 : $form.offset().top - offset
        }, 150);
    }

    function onAjaxLoad($form) {
        // force recaptcha to re-initialize on a form replacement, but not on initial page load, for performance reasons
        initializeRecaptcha($form, true);
        scrollToFormTop($form);
        toggleStylesForIE();
        if (document.getElementsByClassName('ws-nav__hidden-results-view')[0]) {
            setTimeout(function () {
                document.getElementsByClassName('ws-nav__hidden-results-view')[0].remove();
            }, 100);
        }
    }

    function resetCalculatorForm($form) {
        let $formContent = $form.parents(".ws-content--custom-form");

        $formContent.find(".ws-form__fields").removeClass("d-none");
        $formContent.find(".ws-material-group__required-fields").removeClass("d-none");
        $formContent.find(".ws-form__calculator-results").addClass("d-none");

        toggleStylesForIE();
        clearStickyCtas($form);
        scrollToFormTop($form);
    }

    function toggleRelatedFormFields($form, show) {
        // some forms should hide some related content when the success message is shown that may not necessarily be within the <form>
        const $hideOnFormSuccess = $form.parents("[data-ws-hide-on-form-success]");
        $hideOnFormSuccess.each(function (index, el) {
            const $el = $(el);
            const $targets = $el.find($el.data("ws-hide-on-form-success"));
            $targets.toggleClass("d-none", !show);
        });
    }

    $(document).on("click", ".ws-material-group__tool-input-increment--down", function (e) {
        e.preventDefault();
        let $numInput = $(this).siblings(".ws-material-group__input");
        if ($numInput.length) {
            let newInputValue = (parseInt($numInput.val()) - parseInt($numInput.data("ws-step"))).toString();

            $numInput.val(newInputValue);
            $numInput.valid(); // re-run input validation to prevent error messages
        }
    });

    $(document).on("click", ".ws-material-group__tool-input-increment--up", function (e) {
        e.preventDefault();
        let $numInput = $(this).siblings(".ws-material-group__input");
        if ($numInput.length) {
            let newInputValue = (parseInt($numInput.val()) + parseInt($numInput.data("ws-step"))).toString();

            $numInput.val(newInputValue);
            $numInput.valid(); // re-run input validation to prevent error messages
        }
    });

    // Handles toggling the visibility of the SSN input field when the eye icon button is clicked
    $(document).on('click', '.ws-material-group__tool-button-ssn', function (e) {
        e.preventDefault();
        const $btn = $(this);
        const $input = $btn.closest('.ws-material-group').find('input[data-mask="ssn"]');
        if ($input.length === 0) return;

        const isVisible = $input.data('ssn-visible') === true;
        if (isVisible) {
            // Mask it
            $input.attr('type', 'password').data('ssn-visible', false);
            $btn.find('i').removeClass('fa-eye-slash').addClass('fa-eye');
            $btn.attr('aria-label', 'Click to show SSN').attr('aria-pressed', 'false');
        } else {
            // Show it
            $input.attr('type', 'text').data('ssn-visible', true);
            $btn.find('i').removeClass('fa-eye').addClass('fa-eye-slash');
            $btn.attr('aria-label', 'Click to hide SSN').attr('aria-pressed', 'true');
        }
    });

    $(document).on("click", ".ws-form__fields button[type='submit'], .ws-form__container button[type='submit']", function (e) {
        // store the clicked button to set the loading class on during submit
        let $form = $(this).parents("form");
        $form.data("ws-button-clicked", $(this).attr("name"));
    });

    $(document).on("click", ".ws-ajax-submit", function (e) {
        let $form = $(this).parents("form");
        if ($form.valid()) {
            let $wrapper = $form.parents(".ws-content--custom-form");
            $(document).one("ajaxStop", () => {
                // Wait for reCaptcha challenge to complete before submitting form (if recaptcha exists and there is no value)
                let $recaptchaResponse = $form.find(".ws-recaptcha__response");
                if ($recaptchaResponse.length && !$recaptchaResponse.val()) {
                    return;
                }
                ajaxSubmit($wrapper, !$(this).hasClass("ws-ajax-submit--calcxml"));
                // Clear the value of the form .ws-recaptcha__response so form can be submitted more than once without refreshing the page
                $recaptchaResponse.val("");
                $(this).removeAttr("formnovalidate");

                // If there are file upload inputs, clear the inputFileMaps associated with them
                const $fileInputs = $form.find('.ws-form__file-upload-input');
                $fileInputs.each(function (index, input) {
                    window.WSFileUpload.clearFileInputMap(input);
                });
            });
        }
    });

    $(document).on("click", ".ws-form__success-reset-form", function (e) {
        e.preventDefault();
        let $formContent = $(e.target).parents(".ws-content--custom-form");
        resetForm($formContent);
    });

    $(document).on("click", ".ws-success .ws-form__calculator-edit-answers", function (e) {
        e.preventDefault();
        let $form = $(e.target).parents("form");
        resetCalculatorForm($form);
    });

    $(document).on("click", ".ws-form--navigation_next, .ws-form--navigation_back", function() {
        let $navButton = $(this);
        let $form = $navButton.parents("form");
        let navType = $navButton.hasClass("ws-form--navigation_next") ? "NEXT" : ($navButton.hasClass("ws-form--navigation_back") ? "BACK" : "ERROR");

        // Only track successful navigations; BACK nav ignores form validation
        if (navType !== "ERROR" && ($form.valid() || navType === "BACK")) {
            let formName = $form.find(".ws-form--custom").data("form-name");
            let navLabel = $navButton.data("form-nav-label");

            pushFormNavigationGTMEvent(formName, navType, navLabel);
        }
    });

    $select.on("change", function () {
        $madlibButton.attr({
            "href": this.value || "javascript:void(0);",
            "target": $(this.options[this.selectedIndex]).data("link-target")
        });
    });

    $inlineSelect.on("change", function (event) {
        let $target = $(event.currentTarget);
        selectResize($target);
    });

    $(window).bind("mousewheel", function () {
        // allow user scroll to interrupt a scroll animation in progress
        $("html, body").stop();
    });

    $(window).on("resize", _debounce(function () {
        resizeAllSelects();

        // IE sucks, without some arbitrary style change, the image was not staying centered on calculator results page
        if (window.document.documentMode) {
            let $img = $(".ws-success .img-fluid");
            setTimeout(function () { $img.css("padding-bottom", ""); }, 20);
            setTimeout(function () { $img.css("padding-bottom", "1px"); }, 0);
        }
    }, 200));

    // Madlib Toggle Group
    $('.ws-madlib-group-toggle').on('change', function () {
        let groupToShow = $(this).val();
        let $container = $(this).parents($(this).data('ws-toggle-container'));
        let $targets = $container.find($(this).data('ws-toggle-target'));
        let activeClass = 'ws-madlib-group--active';

        $targets.each(function (index, item) {
            let toggleValue = $(item).data('ws-toggle-value');
            let newState = toggleValue ? groupToShow === toggleValue : !$(item).hasClass(activeClass);

            $(item).toggle(newState);
            $(item).toggleClass(activeClass, newState);
        });
    });

    $('.ws-textbox-autocomplete').on('keydown', function (e) {
        let code = e.keyCode || e.which;

        if (code === 27) { // escape
            $(this).toggleClass('ws-textbox-autocomplete--active', false);
            return;
        } else {
            $(this).toggleClass('ws-textbox-autocomplete--active', true);
        }

        if (code !== 38 && code !== 40 && code !== 13 && code !== 27) return;

        let $container = $(this).hasClass('ws-textbox-autocomplete') ? $(this) : $(this).parents('.ws-textbox-autocomplete');

        let $currentItem = $container.find(autocompleteItemSelector + '.selected');

        if (code === 13) { // enter
            if ($currentItem.length) {
                $currentItem[0].click();
            }

            return;
        }

        e.preventDefault();

        let $allItems = $container.find(autocompleteItemSelector);
        let currentItemIndex = $allItems.index($currentItem);
        let $itemToFocus;

        if (code === 38) { // up
            if (currentItemIndex > 0) {
                $itemToFocus = $($allItems[currentItemIndex - 1]);
            } else {
                $itemToFocus = $allItems.last();
            }
        } else if (code === 40) { // down
            if (currentItemIndex < $allItems.length - 1) {
                $itemToFocus = $($allItems[currentItemIndex + 1]);
            } else {
                $itemToFocus = $allItems.first();
            }
        }

        $allItems.removeClass('selected');

        if ($itemToFocus) {
            $itemToFocus.addClass('selected');
        }
    });

    $('.ws-textbox-autocomplete').on('blur', function (e) {
        let $target = $(this);

        setTimeout(function () {
            $target.toggleClass('ws-textbox-autocomplete--active', false);
        }, 100);
    });

    $('.ws-textbox-autocomplete').on('focus', function (e) {
        let $target = $(this);
        $target.toggleClass('ws-textbox-autocomplete--active', true);
    });

    $(document).on('blur', inputSelector, function (e) {
        let $this = $(this);
        toggleHasValueClass($this);
        if (typeof $this.valid === "function") {
            $this.valid();
        }
    });

    $(document).on('keydown', 'input[data-format="phone"]', function (e) {
        let code = e.keyCode || e.which;
        if (Number(code) !== 9 && Number(code) !== 39) { // tab or right arrow
            formatPhoneNumber(e.target);
        }
    });

    $(document).on('keydown', 'input[data-format="numeric"]', function (e) {
        let code = e.which || e.keyCode;
        return (code >= 48 && code <= 57); // numbers
    });

    $(document).on('reset', '.ws-content--custom-form form', function (e) {
        // reset all form validation styles
        let $form = $(this);
        let $wrapper = $form.parents(".ws-dialog__content-wrapper");
        $wrapper.find(".ws-form__fields").removeClass("d-none");
        $wrapper.find(".ws-material-group__required-fields").removeClass("d-none");
        $form.find('.ws-material-group').removeClass('ws-material-group--theme_error');
        toggleAllHasValueClasses();
        resetCalculatorForm($form);
        toggleRelatedFormFields($form, true);
    });

    $(document).ajaxComplete(function () {
        toggleAllHasValueClasses();
        inputMaskInitialized = false;
        initializeInputMask();
    });

    //CCPA External Form Submission
    $(".ws-form__ccpa-external #RequestOnBehalfOf").change(function () {
        $(".ws-form__ccpa-external #ws-form-proxy-section_hidden").toggleClass("ws-form-section_hidden", !this.checked);
    });

    $(".ws-form__ccpa-external #RequestType").change(function () {
        let val = $(this).val();

        if (val === "1") {
            $(".ws-form__ccpa-external #ws-form-section_hidden").toggleClass("ws-form-section_hidden", false);
            $(".ws-form__ccpa-external #ws-form-request-sub-type-section_hidden").toggleClass("ws-form-section_hidden", false);
            $(".ws-form__ccpa-external #ws-form-request-perjury-section_hidden").toggleClass("ws-form-section_hidden", false);
        } else {
            const isOptInOrOutType = val === "3" || val === "4";
            $(".ws-form__ccpa-external #ws-form-section_hidden").toggleClass("ws-form-section_hidden", isOptInOrOutType);
            $(".ws-form__ccpa-external #ws-form-request-sub-type-section_hidden").toggleClass("ws-form-section_hidden", true);
            $(".ws-form__ccpa-external #ws-form-request-perjury-section_hidden").toggleClass("ws-form-section_hidden", isOptInOrOutType);
        }
    });

    $(document).on('focus', inputMaskSelector, function (e) {
        initializeInputMask();
    });

    $(document).ajaxComplete(setFormGroupValidationOffsets);

    // lazy-initialize recaptcha when a form receives focus
    if ($(recaptchaSelector).length) {
        $(document).on('focus', 'form, form *', function (e) {
            if (e.currentTarget === e.target) {
                let $target = $(e.target);
                let $form = $target.is('form') ? $target : $target.closest('form');
                initializeRecaptcha($form);
            }
        });
    }

    init();

    exports.initializeRecaptcha = initializeRecaptcha;
    exports.applyStickyCtas = applyStickyCtas;
    exports.displaySuccessMessage = displaySuccessMessage;
    exports.onAjaxLoad = onAjaxLoad;
    exports.pushFormSubmissionGTMEvent = pushFormSubmissionGTMEvent;
    exports.resetForm = resetForm;
    window.WS = window.WS || {};
    window.WS.Forms = exports;

    // ajaxFailure is defined in Sitecore's form.validate.js but for some reason it is undefined
    window.ajaxFailure = function (xhr, status, error) {
        // reset any disabled buttons
        $("form button")
            .prop("disabled", false)
            .removeClass("ws-btn--loading");

        const errorText = error && error.length ? error : 'Oops! Something went wrong. Please try again.';
        alert(errorText);
    }
});